export const USER_SESSION_TIMEOUT_MS = 10 * 60 * 1000;
export const USER_SESSION_ACTIVITY_KEY = "fliplottery:user:last-activity";
export const USER_SESSION_LOGOUT_KEY = "fliplottery:user:logout";
export const USER_SESSION_FLASH_KEY = "fliplottery:user:flash-message";
export const USER_SESSION_CHANNEL_NAME = "fliplottery:user:session";
export const USER_SESSION_EXPIRED_MESSAGE =
  "Your session has expired due to inactivity. Please log in again.";
export const USER_AUTH_EXPIRED_MESSAGE = "Your session has expired. Please log in again.";
export const API_SESSION_EXPIRED_MESSAGE = "Session expired due to inactivity.";
export const ACCESS_RESTRICTION_CODE = "ACCESS_TEMPORARILY_RESTRICTED";

const USER_SESSION_ERROR_MESSAGES = new Set([
  API_SESSION_EXPIRED_MESSAGE,
  "Invalid or expired token",
  "Refresh session expired",
  "Refresh session not found"
]);

export const getRemainingSessionMs = (lastActivityAt, timeoutMs = USER_SESSION_TIMEOUT_MS) => {
  const lastActivityMs = Number(lastActivityAt || 0);

  if (!Number.isFinite(lastActivityMs) || lastActivityMs <= 0) {
    return timeoutMs;
  }

  return Math.max(timeoutMs - (Date.now() - lastActivityMs), 0);
};

export const shouldHandleUserSessionExpiry = (responsePayload, statusCode) => {
  const message = String(responsePayload?.message || "").trim();
  return (
    (statusCode === 401 && USER_SESSION_ERROR_MESSAGES.has(message)) ||
    (statusCode === 403 && responsePayload?.code === ACCESS_RESTRICTION_CODE)
  );
};

export const getUserSessionExpiryMessage = (responsePayload) =>
  responsePayload?.code === ACCESS_RESTRICTION_CODE
    ? String(responsePayload?.message || USER_AUTH_EXPIRED_MESSAGE).trim()
    : String(responsePayload?.message || "").trim() === API_SESSION_EXPIRED_MESSAGE
    ? USER_SESSION_EXPIRED_MESSAGE
    : USER_AUTH_EXPIRED_MESSAGE;

export const persistUserSessionMessage = (message) => {
  if (typeof window === "undefined") {
    return;
  }

  window.sessionStorage.setItem(USER_SESSION_FLASH_KEY, message);
};

export const consumeUserSessionMessage = () => {
  if (typeof window === "undefined") {
    return "";
  }

  const message = window.sessionStorage.getItem(USER_SESSION_FLASH_KEY) || "";
  if (message) {
    window.sessionStorage.removeItem(USER_SESSION_FLASH_KEY);
  }
  return message;
};

export const publishUserActivity = (timestamp = Date.now()) => {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.setItem(USER_SESSION_ACTIVITY_KEY, String(timestamp));
};

export const clearUserSessionActivity = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.localStorage.removeItem(USER_SESSION_ACTIVITY_KEY);
};

export const broadcastUserLogout = ({ reason = "manual", message = "" } = {}) => {
  if (typeof window === "undefined") {
    return;
  }

  if (message) {
    persistUserSessionMessage(message);
  }

  window.localStorage.setItem(
    USER_SESSION_LOGOUT_KEY,
    JSON.stringify({
      reason,
      message,
      timestamp: Date.now()
    })
  );
};

export const createUserSessionChannel = () => {
  if (typeof window === "undefined" || typeof window.BroadcastChannel === "undefined") {
    return null;
  }

  return new window.BroadcastChannel(USER_SESSION_CHANNEL_NAME);
};
